import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { Col, Container, Row } from 'react-bootstrap'
import { Box, InnerHeading, MainHeading, SpanStyled } from '../../ui/Elements'
import { ArrowBtnBrown, ComMap, MBS, StatsBg1, StatsBg2, StatsBg3, StatsBg4, StripeBg, StripeBgAr, Vision, VisionAr, VisionBg, VisionBgAr } from '../../ui/AllImages'
import { useInView } from 'react-intersection-observer'
import { useTranslation } from 'react-i18next'
import { AboutBox } from '../../ui/CustomElements'
import i18n from '../../Languages/INEXT'
import { VisionMissionList } from '../projectData/Data'
import { Animate } from 'react-simple-animate'
const AboutCompany = () => {
    const { t } = useTranslation()
    const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // When visible, set to true
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // run animation once
        }
      },
      {
        threshold: 0.1, // 20% of section visible triggers the animation
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);
    const start = { opacity: 0, transform: 'translateY(-40px)' };
    const end = { opacity: 1, transform: 'translateY(0)' };
    const start2 = { opacity: 0, transform: 'translateY(100px)' };
    const end2 = { opacity: 1, transform: 'translateY(0)' };
    return (

        <Col md={12} className='about-col-wrap about-com-col-wrap' ref={sectionRef}>
            <Row className='aboutComRow'>
                <Col lg={6} md={12} className='com-col com-col-img'>
                <Animate
                            play={isVisible}
                            duration={1}
                            delay={1}
                            start={start}
                            end={end}
                        >
                    <img src={ComMap} alt="map" />
                    </Animate>
                </Col>
                <Col lg={6} md={12} className='about-com-col'>
                <Animate
                            play={isVisible}
                            duration={1}
                            delay={.5}
                            start={start}
                            end={end}
                        >
                    <InnerHeading className='sub-heading sub-heading-about' color="var(--secondaryColor)">
                        {t('aboutH2')}
                    </InnerHeading>
                    </Animate>
                    <Animate
                            play={isVisible}
                            duration={1}
                            delay={1}
                            start={start}
                            end={end}
                        >
                    <MainHeading className='main-heading main-heading-about' color="var(--themeColor)">
                        {t('aboutH3')}
                    </MainHeading>
                    </Animate>
                    <Animate
                            play={isVisible}
                            duration={1}
                            delay={1.5}
                            start={start}
                            end={end}
                        >
                    <SpanStyled className='aboutComText mt-3' color="var(--themeColor)">
                        {t('aboutT3')}&nbsp;<span className='engReg'>2030.</span>
                    </SpanStyled>
                    </Animate>
                </Col>
                
            </Row>
        </Col>

    )
}


export default AboutCompany
